import tCard from './card.vue';

export default {
  install(instance: any) {
    instance.component('tCard', tCard);
  },
};
